import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e1a61b7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-pa-md" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "well well-sm" }
const _hoisted_4 = { class: "panel" }
const _hoisted_5 = { class: "q-pa-md" }
const _hoisted_6 = { style: {"display":"flex","align-items":"center","margin-bottom":"15px"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--medium" }, "Pontaj prezenta", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { style: {"display":"flex","align-items":"start"} }
const _hoisted_10 = { style: {"width":"65%","display":"flex","flex-direction":"row"} }
const _hoisted_11 = { style: {"display":"flex","flex-direction":"column","width":"100%"} }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Id", -1))
const _hoisted_14 = { class: "col-8 form__label__black" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Tipul de pontaj", -1))
const _hoisted_17 = { class: "col-8 form__label__black" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Nume prenume", -1))
const _hoisted_20 = { class: "col-8 form__label__black" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Descriere", -1))
const _hoisted_23 = { class: "col-8 form__label__black" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "La data", -1))
const _hoisted_26 = { class: "col-8 form__label__black" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Ore pontate", -1))
const _hoisted_29 = { class: "col-8 form__label__black" }
const _hoisted_30 = {
  key: 0,
  style: {"width":"35%","display":"flex","flex-direction":"row","justify-content":"center","align-items":"center"}
}
const _hoisted_31 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_32 = { style: {"display":"flex","align-items":"center","justify-content":"center","width":"100%"} }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--medium" }, "Documente atasate", -1))
const _hoisted_34 = {
  class: "text__label--thin",
  style: {"width":"100%","text-align":"center"}
}
const _hoisted_35 = { style: {"display":"flex","align-items":"center","justify-content":"center","width":"100%"} }
const _hoisted_36 = {
  key: 1,
  class: "table table-bordered table-condensed table-responsive",
  style: {"width":"100%","max-height":"50vh"}
}
const _hoisted_37 = {
  class: "desktop-only",
  style: {"max-width":"30vw"}
}
const _hoisted_38 = { class: "mobile-only" }
const _hoisted_39 = {
  key: 0,
  clas: "row",
  style: {"margin-top":"5px","margin-bottom":"15px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner_gears = _resolveComponent("q-spinner-gears")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_DialogOpenScan = _resolveComponent("DialogOpenScan")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_TaskList = _resolveComponent("TaskList")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loadingData)
      ? (_openBlock(), _createBlock(_component_q_spinner_gears, {
          key: 0,
          color: "primary",
          size: "4em",
          class: "absolute-center"
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_q_form, { ref: "myForm" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", {
                        class: _normalizeClass({
                    column: _ctx.$q.platform.is.mobile,
                    row: _ctx.$q.platform.is.desktop,
                  })
                      }, _hoisted_8, 2)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _hoisted_13,
                            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.prezenta.id), 1)
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            _hoisted_16,
                            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.prezenta.tip_pontaj_prezenta), 1)
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _hoisted_19,
                            _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.prezenta.user_id?.last_name + ' ' + _ctx.prezenta.user_id?.first_name), 1)
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _hoisted_22,
                            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.prezenta.descriere), 1)
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _hoisted_25,
                            _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.prezenta.pontaj_date), 1)
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _hoisted_28,
                            _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.prezenta.efort), 1)
                          ])
                        ])
                      ]),
                      (_ctx.prezenta.appid_tip_pontaj_prezenta?.appid == 1 && _ctx.prezenta.id !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("div", {
                                class: _normalizeClass({
                        column: _ctx.$q.platform.is.mobile,
                        row: _ctx.$q.platform.is.desktop,
                        })
                              }, [
                                _createElementVNode("div", _hoisted_32, [
                                  _createElementVNode("div", null, [
                                    _hoisted_33,
                                    _withDirectives(_createElementVNode("div", _hoisted_34, " Nimic atasat ", 512), [
                                      [_vShow, 
                                  _ctx.prezenta.scan_documents != null &&
                                  _ctx.prezenta.scan_documents.length == 0 &&
                                  !_ctx.uploadingFileToServer
                              ]
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_35, [
                                  _createElementVNode("div", null, [
                                    (_ctx.uploadingFileToServer)
                                      ? (_openBlock(), _createBlock(_component_q_spinner, {
                                          key: 0,
                                          color: "primary",
                                          size: "3em",
                                          thickness: 10
                                        }))
                                      : (_openBlock(), _createElementBlock("table", _hoisted_36, [
                                          _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prezenta.scan_documents, (scan) => {
                                              return (_openBlock(), _createElementBlock("tr", {
                                                key: scan.appid
                                              }, [
                                                _createElementVNode("td", null, _toDisplayString(scan.file_ext), 1),
                                                _createElementVNode("td", null, _toDisplayString(_ctx.humanReadableBytes(scan.file_size)), 1),
                                                _createElementVNode("td", null, [
                                                  _createElementVNode("div", _hoisted_37, _toDisplayString(scan.description), 1),
                                                  _createElementVNode("div", _hoisted_38, _toDisplayString(scan.description), 1)
                                                ]),
                                                _createElementVNode("td", null, [
                                                  _createVNode(_component_q_btn, {
                                                    round: "",
                                                    color: "black",
                                                    icon: "cloud_download",
                                                    size: "xs"
                                                  }),
                                                  _createVNode(_component_q_menu, {
                                                    fit: "",
                                                    "transition-show": "scale",
                                                    "transition-hide": "scale"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_DialogOpenScan, {
                                                        appid: scan.appid,
                                                        type_scan: "PontajPrezenta"
                                                      }, null, 8, ["appid"])
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ])
                                              ]))
                                            }), 128))
                                          ])
                                        ]))
                                  ])
                                ])
                              ], 2)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (_ctx.prezenta.stare !== 'initiat')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _createVNode(_component_TaskList, {
                          appid: _ctx.appid,
                          task: _ctx.task,
                          onState: _ctx.onState,
                          isSuccess: _ctx.isSuccess
                        }, null, 8, ["appid", "task", "onState", "isSuccess"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }, 512)
        ]))
  ]))
}